/**
 * Normalize a string for sorting in a specific locale.
 *
 * This function normalizes the string using Unicode Normalization Form D (NFD)
 * which splits accents from their base characters. It then removes all diacritics
 * and punctuation, and finally converts the string to lower case in the
 * specified locale.
 *
 * @param {string} locale - The locale to use for sorting.
 * @param {string} value - The string to normalize.
 * @returns {string} The normalized string.
 */
export function normalizeStringForSort(locale, value) {
    return (value ?? '')
        .normalize('NFD') // split accents
        .replace(/\p{Diacritic}/gu, '') // remove accents
        .replace(/\p{P}/gu, '') // remove punctuation
        .toLocaleLowerCase(locale);
}
